import React from 'react'
import { Modal } from '@enamelai/design-system'
import { Icon as Delete2Icon } from '@enamelai/design-system/icons/Delete2'

export type DeleteConfirmationModalProps = {
  show: boolean
  onHide: () => void
  onConfirm: () => void
  entityName?: string
  title?: string
  message?: string
  confirmButtonText?: string
  confirmDisabled?: boolean
  /** When set, replaces the default "{message} {entityName}?" body. */
  bodyText?: string
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  show,
  onHide,
  onConfirm,
  entityName = '',
  title = 'Confirm deletion',
  message = 'Are you sure you want to delete',
  confirmButtonText = 'Delete',
  confirmDisabled = false,
  bodyText,
}) => {
  const description =
    bodyText ??
    (entityName ? `${message} ${entityName}?` : 'This cannot be undone.')

  return (
    <Modal
      open={show}
      onClose={onHide}
      size="sm"
      variant="confirmation"
      title={title}
      description={description}
      icon={<Delete2Icon width={16} height={16} aria-hidden="true" />}
      iconTone="danger"
      primaryLabel={confirmButtonText}
      primaryDestructive
      primaryDisabled={confirmDisabled}
      onPrimaryClick={onConfirm}
      secondaryLabel="Cancel"
      onSecondaryClick={onHide}
    />
  )
}

export default DeleteConfirmationModal
